import { render, staticRenderFns } from "./ResourceCalendarCreate.vue?vue&type=template&id=7f6bf484&scoped=true"
import script from "./ResourceCalendarCreate.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bf484",
  null
  
)

export default component.exports